import React from "react"
import { HistoryRouter as Router } from "redux-first-history/rr6"
import { Routes, Route } from "react-router-dom"

import {
  CONSENT_MATCH,
  PAYMENT_SCHEDULE_CREATE_MODAL_MATCH,
  PAYMENT_SCHEDULE_VIEW_MODAL_MATCH,
  PAYMENT_SCHEDULE_SIGN_MODAL_MATCH,
  CLIENT_EMAIL_CONFIRMATION_MATCH,
  PAYMENT_SCHEDULE_PROMISE_MODAL_MATCH,
  PAYMENT_SCHEDULE_FALLBACK_MATCH,
  CLIENT_PROFILE_MATCH,
  CLIENT_SUBSCRIPTIONS_MATCH,
  CLIENT_INVOICES_MATCH,
  BATCH_PAYMENT_PAY_MATCH,
  PAYMENT_SUCCESS_MATCH,
  PAYMENT_FAILURE_MATCH,
  SUBSCRIPTION_CREATE_MATCH,
  SUBSCRIPTION_UPGRADE_MATCH,
  SUBSCRIPTION_CANCEL_MATCH,
  SUBSCRIPTION_PAY_MATCH,
  SUBSCRIPTION_SUCCESS_MATCH,
  SUBSCRIPTION_FAILURE_MATCH,
  ISSUE_CREATE_MODAL_MATCH,
  HELP_HOW_MATCH,
  HELP_WHY_MATCH,
  HELP_WHEREFORE_MATCH,
  HELP_WHAT_MATCH,
} from "config"

import PublicLayout from "components/Layout/Public"
import ProtectedLayout from "components/Layout/Protected"

import ProtectedRoute from "routes/protected"

import {
  Claims,
  Payments,
  Messages,
  Profile,
  Subscription,
  Invoices,
  Services,
} from "pages/dashboard"
import {
  Terms,
  Privacy,
  Cookie,
  Help,
  SubscriptionTerms,
  NotFound,
} from "pages/static"
import { Login, IdCard, MobileId, SmartId, Banks } from "pages/sessions"

import { history } from "redux/store"

export default (
  <Router history={history}>
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/login/id_card/new" element={<IdCard />} />
        <Route path="/login/mobile_id/new" element={<MobileId />} />
        <Route path="/login/smart_id/new" element={<SmartId />} />
        <Route path="/login/banks/new" element={<Banks />} />

        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookie" element={<Cookie />} />

        <Route path="*" element={<NotFound />} />
      </Route>

      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<ProtectedRoute component={Claims} />} />

        <Route
          path={CONSENT_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={PAYMENT_SCHEDULE_CREATE_MODAL_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={PAYMENT_SCHEDULE_VIEW_MODAL_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={PAYMENT_SCHEDULE_SIGN_MODAL_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={PAYMENT_SCHEDULE_PROMISE_MODAL_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={PAYMENT_SCHEDULE_FALLBACK_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={ISSUE_CREATE_MODAL_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={BATCH_PAYMENT_PAY_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={PAYMENT_SUCCESS_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={PAYMENT_FAILURE_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={HELP_HOW_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={HELP_WHY_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={HELP_WHEREFORE_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />
        <Route
          path={HELP_WHAT_MATCH}
          element={<ProtectedRoute component={Claims} />}
        />

        <Route
          path="/payments"
          element={<ProtectedRoute component={Payments} />}
        />

        <Route
          path={SUBSCRIPTION_CREATE_MATCH}
          element={<ProtectedRoute component={Subscription} />}
        />
        <Route
          path={SUBSCRIPTION_UPGRADE_MATCH}
          element={<ProtectedRoute component={Subscription} />}
        />
        <Route
          path={SUBSCRIPTION_CANCEL_MATCH}
          element={<ProtectedRoute component={Subscription} />}
        />
        <Route
          path={SUBSCRIPTION_PAY_MATCH}
          element={<ProtectedRoute component={Subscription} />}
        />
        <Route
          path={SUBSCRIPTION_SUCCESS_MATCH}
          element={<ProtectedRoute component={Subscription} />}
        />
        <Route
          path={SUBSCRIPTION_FAILURE_MATCH}
          element={<ProtectedRoute component={Subscription} />}
        />
        <Route
          path={CLIENT_SUBSCRIPTIONS_MATCH}
          element={<ProtectedRoute component={Subscription} />}
        />

        <Route
          path={CLIENT_INVOICES_MATCH}
          element={<ProtectedRoute component={Invoices} />}
        />

        <Route
          path="/services"
          element={<ProtectedRoute component={Services} />}
        />

        <Route
          path="/messages"
          element={<ProtectedRoute component={Messages} />}
        />

        <Route
          path={CLIENT_PROFILE_MATCH}
          element={<ProtectedRoute component={Profile} />}
        />
        <Route
          path={CLIENT_EMAIL_CONFIRMATION_MATCH}
          element={<ProtectedRoute component={Profile} />}
        />

        <Route path="/pages/help" element={<Help />} />
        <Route path="/pages/terms" element={<Terms />} />
        <Route path="/pages/privacy" element={<Privacy />} />
        <Route path="/pages/cookie" element={<Cookie />} />
        <Route path="/pages/subscription" element={<SubscriptionTerms />} />
      </Route>
    </Routes>
  </Router>
)
